import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import { Box, Typography, Button } from '@mui/material';

const WelcomeImage = () => {
    const [showMore, setShowMore] = useState(false);

    const toggleContent = () => {
        setShowMore(!showMore);
    };

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
                height: { xs: 'auto', sm: '20vh', md: '100vh', lg: '100vh' },
                width: '100%',
                backgroundColor: { xs: 'transparent', md: 'primary.main' },
                display: 'flex',
                flexDirection: { xs: 'row', sm: 'row', md: 'column', lg: 'column' },
                justifyContent: 'center',
                padding: 2,
            }}
        >
            <Box sx={{ width: { xs: '40%', sm: '30%', md: '20%', lg: '20%' } }}>
                <img src="assets/images/logo.png" alt="logo" width="100%" />
            </Box>

            <Box
                sx={{
                    maxWidth: { xs: '100%', sm: '80%', md: '70%', lg: '60%' },
                    display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' },
                    textAlign: 'center',
                    marginTop: 2,
                    padding: 2,
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                        color: '#fff',
                    }}
                >
                    अग्रवाल प्रोजेक्ट्स
                </Typography>
                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#fff',
                        marginTop: 1,
                        opacity: 0.8,
                    }}
                >
                    श्री अग्रसेनजी जयते, आज पूरे भारत में लाखों की संख्या में अग्रवाल समाज हर क्षेत्र में आगे है।
                    अग्रवाल समाज में एक व्यवसायी के रूप में विशेष रूप से जाने जाते हैं।
                </Typography>

                {showMore && (
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#fff',
                            marginTop: 2,
                            opacity: 0.9,
                        }}
                    >
                        हमारे संस्थापक श्री महाराजा अग्रसेनजी ने भी समाज में जरूरतमंदों के लिए एक रुपया और एक ईंट की
                        मांग की थी ताकि जरूरतमंद अग्रवाल बंधु सामथर्यवान से सहयोग प्राप्त कर सक्षम बन सकें और अपना घर और
                        व्यवसाय चला सकें। इस प्रकार उनके पुनर्वास की व्यवस्था की गई ताकि समाज में कोई भी व्यक्ति पीछे न
                        छूटे, दानदाता पर बोझ न पड़े और सहयोग की भावना भी बनी रहे। और अग्रवाल समाज के सभी लोगों को मिलजुल
                        कर रहना चाहिए।
                    </Typography>
                )}

                <Button
                    variant="text"
                    onClick={toggleContent}
                    sx={{
                        color: '#fff',
                        marginTop: 2,
                        fontWeight: 'bold',
                        backgroundColor: 'transparent',
                        '&:hover': { backgroundColor: 'transparent', color: 'secondary.main' },
                        textTransform: 'uppercase',
                    }}
                >
                    {showMore ? 'Show Less' : 'Show More'}
                </Button>
            </Box>
        </Stack>
    );
};

export default WelcomeImage;
